export type AssetType =
  | "pbp"
  | "image"
  | "video"
  | "graphics"
  | "audio"
  | "gif"
  | "story"
  | "replay"
  | "stream"
  | "reaction"
  | "duplicate"
  | "press-conf-child"
  | "press-conf-answer"
  | "press-conf-question"
  | "studio-show-chapter";

export const ICONS_MAP: Record<AssetType, string> = Object.freeze({
  pbp: "WscIconPbp",
  image: "image",
  video: "videocam",
  graphics: "WscIconGraphicsAsset",
  audio: "graphic_eq",
  gif: "gif_box",
  story: "WscIconStory",
  replay: "WscIconReplay",
  stream: "WscIconStream",
  reaction: "ar_on_you",
  duplicate: "WscIconDuplicate",
  "press-conf-child": "arrow_right_alt",
  "press-conf-answer": "WscIconAnswer",
  "press-conf-question": "WscIconQuestion",
  "press-conf-sequence": "WscIconSequence",
  "studio-show-chapter": "WscIconFilmChapter",
});

export enum IndicatorSize {
  medium = "medium",
  small = "small",
}
